/* eslint-disable */
import { createGlobalStyle } from 'styled-components';
export const GlobalStyles = createGlobalStyle`
 body {
  background: ${({ theme }) => theme.contentWrapper.mainWrapper.bgColor}
} 
.main-heading {
  color: ${({ theme }) => theme.contentWrapper.homeText.headingColor};
}
.cleanBtn {
  background: ${({ theme }) => theme.contentWrapper.filter.background};
  color: ${({ theme }) => theme.contentWrapper.filter.color};
  }
.filterMainDiv .filterBox{
  background: ${({ theme }) => theme.contentWrapper.filterBox.bgColor};
}
.filterMainDiv .filterInput, .filterMainDiv .filterOption, .filterNoVehicle {
  color: ${({ theme }) => theme.contentWrapper.filterBox.color};
}
  .filterDiv .filterInput .searchInput,
  .filterMainDiv .common-date-picker .react-datepicker-wrapper .react-datepicker__input-container input {
  background: ${({ theme }) => theme.contentWrapper.filterBox.bgColor};
  color: ${({ theme }) => theme.contentWrapper.filterBox.color};
  }
 .react-datepicker, .react-datepicker__header {
 background: ${({ theme }) => theme.contentWrapper.datePicker.bgColor};
 }
 .react-datepicker__current-month, .react-datepicker__day, .react-datepicker__day-name {
 color: ${({ theme }) => theme.contentWrapper.datePicker.color};
 }
//  .react-datepicker__day:hover,
//  .react-datepicker__month-text:hover,
//  .react-datepicker__quarter-text:hover,
//  .react-datepicker__year-text:hover {
//   background-color: ${({ theme }) =>
  theme.contentWrapper.datePicker.hoverbg};
//  }
  .modalWrapper {
  background: ${({ theme }) => theme.modal.overlay};
  }
  .modalContent {
  background: ${({ theme }) => theme.modal.wrapper};
}

.dashboard-card {
  background: ${({ theme }) => theme.dashboardStyles.cardBackground.bgColor};
}
  .highcharts-background {
  fill: ${({ theme }) => theme.dashboardStyles.highchartsBackground.fill};
}
.serviceInfoContainer {
  background: ${({ theme }) => theme.dashboardStyles.serviceCard.bgColor};
  box-shadow: ${({ theme }) => theme.dashboardStyles.serviceCard.boxShadow};
} 
 .serviceInfoContainer .remainderText {
  color: ${({ theme }) => theme.dashboardStyles.serviceCard.color};
  }
.dashboardPage .drivingScoreCard .score-value,
.dashboardPage .drivingScoreCard .score-text,
.dashboardPage .drivingScoreCard .total-text {
  color: ${({ theme }) => theme.dashboardStyles.cardHeading.color}
}
.card-heading, .cardLabel {
  color: ${({ theme }) => theme.dashboardStyles.cardHeading.color}
}
.serviceLabel .count, .serviceLabel .service {
 color: ${({ theme }) => theme.dashboardStyles.serviceCard.color}
}
 .serviceLabel .service {
 border-bottom: ${({ theme }) => theme.dashboardStyles.serviceCard.border}
}
.ticker-carousel{
  background: ${({ theme }) => theme.tickerCarousel.bgColor};
}
.ticker-carousel li div{
  color: ${({ theme }) => theme.tickerCarousel.color};
}
.ticker-carousel .notificationIcon {
  color: ${({ theme }) => theme.tickerCarousel.notifyText};
}
.tickerModalContainer .tickerModal {
   background:   ${({ theme }) => theme.tickerCarousel.bgColor} !important;
  }
.tickerModalContainer .tickerModal div, .tickerModalContainer .tickerModal li{
    color: ${({ theme }) => theme.tickerCarousel.color} !important;
}
.cardPrimary, .noDataCard {
  background: ${({ theme }) => theme.cardPrimary.background};
  color: ${({ theme }) => theme.cardPrimary.color};
}
.summaryCard .distance {
  background-image: ${({ theme }) => `url(${theme.summaryStrip.distance})`};
}
.summaryCard .fuel {
  background-image: ${({ theme }) => `url(${theme.summaryStrip.fuel})`};
}
.summaryCard .mileage {
  background-image: ${({ theme }) => `url(${theme.summaryStrip.mileage})`};
}
.summaryCard .running {
  background-image: ${({ theme }) => `url(${theme.summaryStrip.running})`};
}
.summaryCard .idling {
  background-image: ${({ theme }) => `url(${theme.summaryStrip.idling})`};
}
.summaryCard .stopped {
  background-image: ${({ theme }) => `url(${theme.summaryStrip.stopped})`};
}
.summaryCard .stops {
  background-image: ${({ theme }) => `url(${theme.summaryStrip.stops})`};
}
.summaryCard .alerts {
  background-image: ${({ theme }) => `url(${theme.summaryStrip.alerts})`};
}
.summaryCard .duration {
  background-image: ${({ theme }) => `url(${theme.summaryStrip.duration})`};
}
.summaryCard .speed {
  background-image: ${({ theme }) => `url(${theme.summaryStrip.speed})`};
}
.summaryCard .utilization {
  background-image: ${({ theme }) => `url(${theme.summaryStrip.utilization})`};
}
.summaryCard .alertsCount {
  background-image: ${({ theme }) => `url(${theme.alertStrip.alertCount})`};
}
.summaryCard .vehicleCount, .alertsAccordion .vehicleCount {
  background-image: ${({ theme }) => `url(${theme.alertStrip.vehicleCount})`};
}
.summaryCard .uniqueGeofence {
  background-image: ${({ theme }) => `url(${theme.alertStrip.uniqueGeofence})`};
}
.summaryCard .totalEntry {
  background-image: ${({ theme }) => `url(${theme.alertStrip.totalEntry})`};
}
.summaryCard .totalExit {
  background-image: ${({ theme }) => `url(${theme.alertStrip.totalExit})`};
}
.summaryCard .overspeedDuration {
  background-image: ${({ theme }) =>
    `url(${theme.alertStrip.overspeedDuration})`};
}
.summaryCard .neutralDuration {
background-image: ${({ theme }) => `url(${theme.alertStrip.neutralDuration})`};
}
.summaryCard .maxSpeed {
  background-image: ${({ theme }) => `url(${theme.alertStrip.maxSpeed})`};
}
.summaryCard .idlingDuration {
 background-image: ${({ theme }) => `url(${theme.alertStrip.idlingDuration})`};
}
.summaryCard .geofenceStop {
 background-image: ${({ theme }) => `url(${theme.alertStrip.geofenceStop})`};
}
.summaryCard .stopDuration {
 background-image: ${({ theme }) => `url(${theme.alertStrip.stopDuration})`};
}
 .summaryCard .engineoverunDuration {
 background-image: ${({ theme }) =>
   `url(${theme.alertStrip.engineoverunDuration})`};
}
 .summaryCard .maxRPM {
 background-image: ${({ theme }) => `url(${theme.alertStrip.maxRPM})`};
}
  .summaryCard .maxRPM {
 background-image: ${({ theme }) => `url(${theme.alertStrip.maxRPM})`};
}
.alertsAccordion .dpfregen {
  background-image: ${({ theme }) => `url(${theme.alertStrip.dpfregen})`};
}
.alertsAccordion .adblueLow {
  background-image: ${({ theme }) => `url(${theme.alertStrip.adblueLow})`};
}
.alertsAccordion .adblueZone {
  background-image: ${({ theme }) => `url(${theme.alertStrip.adblueZone})`};
}
.alertsAccordion .adblueFault{
  background-image: ${({ theme }) => `url(${theme.alertStrip.adblueFault})`};
}
.alertsAccordion .engineOverrun {
  background-image: ${({ theme }) => `url(${theme.alertStrip.engineOverrun})`};
}
.alertsAccordion .neutralDriving {
  background-image: ${({ theme }) => `url(${theme.alertStrip.neutralDriving})`};
}
.alertsAccordion .geofenceAlt {
  background-image: ${({ theme }) => `url(${theme.alertStrip.geofenceAlt})`};
}
.summaryCard .fuelDropCard,
.alertsAccordion .fuelDrop {
  background-image: ${({ theme }) => `url(${theme.alertStrip.fuelDrop})`};
}
.summaryCard .fuelFillCard,
.alertsAccordion .fuelFill {
  background-image: ${({ theme }) => `url(${theme.alertStrip.fuelFill})`};
}
.alertsAccordion .overSpeedAlt {
  background-image: ${({ theme }) => `url(${theme.alertStrip.overSpeedAlt})`};
}
.alertsAccordion .idlingAlt {
 background-image: ${({ theme }) => `url(${theme.alertStrip.idlingAlt})`};
}
 .alertsAccordion .tripDelay {
  background-image: ${({ theme }) => `url(${theme.alertStrip.tripDelay})`};
}
.alertsAccordion .excessiveDriving {
  background-image: ${({ theme }) =>
    `url(${theme.alertStrip.excessiveDriving})`};
}
.alertsAccordion .nightDriving {
  background-image: ${({ theme }) => `url(${theme.alertStrip.nightDriving})`};
}
.alertsAccordion .cardPrimary .MuiAccordion-root.Mui-expanded,
.settingsPreferences .MuiAccordion-root.Mui-expanded  {
  background: ${({ theme }) => theme.alertsNotification.cardBgColor};
  color: ${({ theme }) => theme.alertsNotification.cardText};
}
.alertsAccordion .cardPrimary .MuiAccordion-root.Mui-expanded .alert-list-card,
.settingsPreferences .MuiAccordion-root.Mui-expanded  .alert-list-card {
  background: ${({ theme }) => theme.alertsNotification.innerCardBg};
  color: ${({ theme }) => theme.alertsNotification.innerText};
}
.alertsAccordion .cardPrimary .MuiAccordionSummary-root,
.settingsPreferences .MuiAccordionSummary-root,
.settingsPreferences .MuiAccordionDetails-root {
background: ${({ theme }) => theme.alertsNotification.innerCardBg};
border-color: ${({ theme }) =>
  theme.alertsNotification.accordionBorderColor} !important;
}
.alertsAccordion .cardPrimary .small-text span {
color: ${({ theme }) => theme.alertsNotification.innerText};
}
.alertsAccordion .cardPrimary .alert-desc {
color: ${({ theme }) => theme.alertsNotification.alertHeading} !important;
}
.titleCard, .dayDate {
  color: ${({ theme }) => theme.trackTrace.routePlayBack.titleColor};
}
.leftPanel .tripCard {
  background: ${({ theme }) => theme.trackTrace.routePlayBack.cardBgColor};
  border-color: ${({ theme }) => theme.trackTrace.routePlayBack.borderColor};
}
.cardSecondary {
  background: ${({ theme }) => theme.cardSecondary.background};
  color: ${({ theme }) => theme.cardSecondary.color};
  box-shadow: ${({ theme }) => theme.cardSecondary.boxShadow};
}
  .geoFencCardHead {
  background-color: ${({ theme }) => theme.trackTrace.geoFencCardHead.bgColor};
}
  .inputTextField {
  color: ${({ theme }) => theme.trackTrace.geoFencCardHead.color};
  }
  .geoCardLine, .geoTableHead {
  color: ${({ theme }) => theme.trackTrace.geoFencCardHead.color};
  }
.geoFencCard { 
  background-color: ${({ theme }) => theme.trackTrace.geoFencCard.bgColor};
}
.footerWrapper{
  background: ${({ theme }) => theme.contentWrapper.footerWrapper.bgColor};
}

.footerWrapper li, .footerWrapper li a, .footerWrapper .subWrapper .footerList {
  color: ${({ theme }) => theme.contentWrapper.footerWrapper.color};
}
.MuiList-root.MuiMenu-list.MuiList-padding{
  background: ${({ theme }) =>
    theme.contentWrapper.filterBox.bgColor} !important;
  color: ${({ theme }) => theme.contentWrapper.filterBox.color} !important;
}

#locationShareBeta .searchDiv .MuiTextField-root .MuiOutlinedInput-root .MuiOutlinedInput-input {
  background: ${({ theme }) =>
    theme.contentWrapper.locationShareSearch.bgColor} !important;
} 
.genericTable thead tr th {
  border: 0.1rem solid ${({ theme }) =>
    theme.contentWrapper.genericTable.tableBorder} !important;
}
.genericTable tbody tr {
  background-color: ${({ theme }) =>
    theme.contentWrapper.genericTable.even} !important;
}
.genericTable tbody tr:nth-of-type(odd) {
  background-color: ${({ theme }) =>
    theme.contentWrapper.genericTable.odd} !important;
}
.genericTable td{
  color: ${({ theme }) =>
    theme.contentWrapper.genericTable.fontTable} !important;
  border: 0.1rem solid ${({ theme }) =>
    theme.contentWrapper.genericTable.tableBorder} !important;
  border-bottom: none !important;
  border-top: none !important;
  text-align: center;
}
.themeChangeLabel {
color: ${({ theme }) => theme.contentWrapper.label.themeChangeLabel} !important;
}
 .react-datepicker-time__header,
.react-datepicker__time-container .react-datepicker__time 
.react-datepicker__time-box ul.react-datepicker__time-list 
li.react-datepicker__time-list-item {
background: ${({ theme }) => theme.contentWrapper.label.themeChangeBg} ;
  color: ${({ theme }) => theme.contentWrapper.label.themeChangeLabel};
}
.genericTable td:nth-child(1) .link-inactive{
  color: ${({ theme }) => theme.contentWrapper.locationShare.color} !important;
}
.sch_alerts label, .formTable td label {
  color: ${({ theme }) => theme.shareReports.color} !important;
}
.sch_alerts .section:before {
  border: ${({ theme }) => theme.shareReports.border} !important;
}

.health-indicator, .health-carousel {
  background: ${({ theme }) => theme.fleetHealth.cardBg};
  color: ${({ theme }) => theme.fleetHealth.color};
}
  .health-indicator .serviceText .title, .health-indicator .serviceText .text {
  color: ${({ theme }) => theme.fleetHealth.color};
  }

  .health-carousel-img, .fleetCode   {
    background: ${({ theme }) => theme.fleetHealth.subCardBg};
}
    .health-carousel-text, .carousel-custom-wrapper .title, .no-dtc-health {
    color: ${({ theme }) => theme.fleetHealth.color};
  }
    .service-card {
    background: ${({ theme }) => theme.fleetHealth.cardBg};
  color: ${({ theme }) => theme.fleetHealth.color};
    }
  .severity-block.service-later {
   background: ${({ theme }) => theme.fleetHealth.serviceBg};
  color: ${({ theme }) => theme.fleetHealth.color};
  border: ${({ theme }) => theme.fleetHealth.serviceBorder};
    }
  .MuiTablePagination-select {
  background-image: ${({ theme }) =>
    `url(${theme.pagination.dropArrow})`} !important;
  }
  .vecihleListPanel, .fluidsGraphPanel, .milageTab {
   background: ${({ theme }) => theme.trends.cardBg};
    color: ${({ theme }) => theme.trends.color};
  }
   .vecihleListPanel .fluidsVecihleListPanel {
   background: ${({ theme }) => theme.trends.tileBg};
   border-color: ${({ theme }) => theme.trends.tileBorder};
    }
   .repSettingsCard .reportListSettings {
   border-bottom: ${({ theme }) => theme.alertsNotification.accordionBorder};
   }
   #settingsPage .leftPanel, #settingsPage .rightPanel,
   #settingsPage .newPopUp, #settingsPage .genericTable thead tr th,
   #settingsPage .cds .MuiStepper-root,
   #settingsPage .cds .stepContent,
   #settingsPage .cds .clearDropdown {
   background: ${({ theme }) => theme.settings.bgColor};
    color: ${({ theme }) => theme.settings.color};
   }
       #settingsPage .newPopUp, #settingsPage .genericTable thead tr th{
          background: ${({ theme }) => theme.settingsPoi.bgColor};
    color: ${({ theme }) => theme.settingsPoi.color};
       }
    #settingsPage .rightPanel .cds .MuiStepLabel-labelContainer .MuiStepLabel-active {
    color: ${({ theme }) => theme.settings.color} !important;
    }
    #settingsPage .rightPanel .titleHead {
    color: ${({ theme }) => theme.settings.color};
   }
    #settingsPage .rightPanel .tableValue,
     #settingsPage .rightPanel .cds .stepContent .content .preview-table td:first-child,
     #settingsPage .rightPanel .deletePopup .deleteHeader,
      #settingsPage .rightPanel .deletePopup .deleteSubHeader {
    color: ${({ theme }) => theme.settings.color};
    }
    #settingsPage .rightPanel .tableValue:nth-child(odd) {
    background: ${({ theme }) => theme.settings.odd};
    }
    #settingsPage .rightPanel .tableValue:nth-child(even) {
    background: ${({ theme }) => theme.settings.even};
    }
    #settingsPage .rightPanel .content .groupView .signal {
    background: ${({ theme }) => theme.settings.cdsService};
    }
    #settingsPage .rightPanel .content .groupView .signal .signalDiv .groupService .services {
    color: ${({ theme }) => theme.settings.cdsServiceText};
    }
    #settingsPage .rightPanel .deletePopup .deleteBody {
    background: ${({ theme }) => theme.modal.innerBg};
    }
    #settingsPage .rightPanel .deletePopup .modalContent .deleteBody .deleteSubBody .dataList .data-items {
    background: ${({ theme }) => theme.modal.wrapper};
    }
    .dialogWindow .MuiDialog-paper .MuiDialogContent-root .infoBox,
    .confirmWindow.dialogWindow .MuiDialog-paper{
    background: ${({ theme }) => theme.modal.innerBg};
    }
    .dialogWindow .MuiDialog-paper .MuiDialogContent-root .subTitle,
    .dialogWindow .MuiDialog-paper .MuiDialogContent-root .infoBox  .subText {
     color: ${({ theme }) => theme.settings.color};
    }
     .dialogWindow .MuiDialog-paper {
     background: ${({ theme }) => theme.modal.wrapper};
     }
     .each-width {
     background: ${({ theme }) => theme.tripManagement.bgColor};
}
    .chart-flex .each-width .graph-heading, .chart-flex .each-width .tripNoDataLegend {
      color: ${({ theme }) => theme.tripManagement.color};
     }
      .secondary-tab {
       background: ${({ theme }) => theme.tripManagement.bgColor};
       color: ${({ theme }) => theme.tripManagement.color};
      }
}
       .vehilefilter-truck{
  background: ${({ theme }) => theme.modal.popupBg};
  color: ${({ theme }) => theme.contentWrapper.label.themeChangeLabel};
}
  .menu-search-truck, .menu-dropdown {
  background: ${({ theme }) => theme.modal.popupBg};
  color: ${({ theme }) => theme.contentWrapper.label.themeChangeLabel};
}
       .popup_overlay_profile .pop-up {
       background: ${({ theme }) => theme.modal.popupBg};
       }
       .popup_contanier {
       background: ${({ theme }) => theme.modal.popupBg};
       }
       .popup_header {
       color: ${({ theme }) => theme.contentWrapper.label.themeChangeLabel};
       }
       .profilePage .table + .hints {
       color: ${({ theme }) => theme.contentWrapper.label.themeChangeLabel};
       }
       .highcharts-legend .highcharts-legend-item text {
        fill: ${({ theme }) =>
          theme.contentWrapper.label.themeChangeLabel} !important;
       }
        .sidepanel {
        background: ${({ theme }) => theme.modal.innerBg} ;
        box-shadow: ${({ theme }) => theme.modal.boxShadow} ;
    }
        .panel-card {
         background: ${({ theme }) => theme.modal.innerCard} ;
}
        .ticker-heading {
        color: ${({ theme }) => theme.contentWrapper.label.themeChangeLabel} ;
        }
        .popup_content .formDiv .inputTextField {
        color: ${({ theme }) => theme.contentWrapper.label.themeChangeLabel} ;
        }
        .popup_content .formDiv .select-vehc .menu-dropdown {
         background: ${({ theme }) => theme.dropdown.bgColor} ;
         color: ${({ theme }) => theme.contentWrapper.label.themeChangeLabel} ;
        }
         .popup_content .formDiv .select-vehc .menu-dropdown label:hover {
         color: ${({ theme }) => theme.contentWrapper.label.themeChangeLabel} ;
         }
         .popup_content .formDiv .select, .popup_content .formDiv input {
          color: ${({ theme }) => theme.contentWrapper.label.themeChangeLabel} ;
         }
          select option { 
          background: ${({ theme }) => theme.dropdown.bgColor} ;
          color: ${({ theme }) => theme.contentWrapper.label.themeChangeLabel} ;
          }
         .profilePage .profilePageContent {
          background: ${({ theme }) => theme.profile.bgColor} ;
         }
          .profilePage .profilePageContent .table tbody,
          .profilePage .profilePageContent .profTab {
          border-bottom:${({ theme }) => theme.profile.border} ;
          }
         .selectedFilterDataDiv {
          background: ${({ theme }) =>
            theme.contentWrapper.selectedFilter.bgColor} ;
          color: ${({ theme }) => theme.contentWrapper.selectedFilter.color} ;
          }
          .showMoreSelectedVehicles{
          background: ${({ theme }) =>
            theme.contentWrapper.selectedFilter.showmoreBg} ;
          }
          .showMoreSelectedVehicles .dropdown-item,
          .showMoreSelectedVehicles .dropdown-item:hover {
          color: ${({ theme }) => theme.contentWrapper.selectedFilter.color} ;
          }
          #simple-popover .MuiAutocomplete-root .MuiAutocomplete-inputRoot {
          color:${({ theme }) => theme.contentWrapper.label.themeChangeLabel} ;
          }
          .popup_content .formDiv input:focus,
          .popup_overlay_profile .form-group .inputField:focus,
          #liveStep .expire-select__control:focus,
          #liveStep .expire-select__control--is-focused {
          border: 0.1rem solid ${({ theme }) =>
            theme.modal.inputFocus} !important;
           background: ${({ theme }) =>
             theme.darrkThemeColor.bgColor} !important;
           color: ${({ theme }) => theme.fleetHealth.color} ;
          }
          .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input,
          #liveStep .startTimePicker input,
          #liveStep .endTimePicker input,
          #liveStep .endTimePickerGen input,
          #liveStep .expire-select__control .expire-select__input,
          #liveStep .expire-select__single-value,
          .cardSecondary.geofence .common-date-picker .react-datepicker-wrapper input {
          color:${({ theme }) => theme.contentWrapper.label.themeChangeLabel} ;
          }
          .drivingAnalysis .cardPrimary.drivingScore .progressVisualFull,
          .drivingAnalysis .cardPrimary.drivingIncidents .progressVisualFull,
          .drivingAnalysis .cardPrimary.singleIncidentCard .progressVisualFull {
          background:${({ theme }) => theme.drivingAnalysis.barColor} ;
          }
          .drivingAnalysis .cardPrimary.driverCategory .apexcharts-pie-area {
          stroke: ${({ theme }) => theme.drivingAnalysis.strokeColor} ;
          }
          .admin-btn .requestStatus .statusTab {
           background: ${({ theme }) => theme.settings.cdsRequestbg};
            color: ${({ theme }) => theme.settings.color};
          }
          .cdsRequest .secondary-tab {
           background: ${({ theme }) => theme.settings.cdsRequestbg};
          }
           .cdsContent .contentHeader,
           .cdsContent .content .ContentDiv .activateProfile .header {
           border-bottom: 0.1rem solid ${({ theme }) =>
             theme.settings.headerBorder};
           }
           .cdsContent .content .ContentDiv .activateProfile {
            border: ${({ theme }) => theme.settings.infoBorder};
           }
           .cdsContent .content .ContentDiv .activateProfile .infoBox {
           background: ${({ theme }) => theme.settings.infoBox};
           }
           .cdsContent {
           color: ${({ theme }) => theme.darrkThemeColor.color} !important;
background: ${({ theme }) => theme.darrkThemeColor.bgColor} !important;
}
           .MuiDialogContent-root, .MuiDialogTitle-root {
           background: ${({ theme }) => theme.settings.bgColor} !important;
           }
.vehicle-selection .MuiPaper-root .MuiAutocomplete-listbox,
.geofence .fleetDropdown .MuiPaper-root .MuiAutocomplete-listbox,
.geofence .fleetDropdown  .selectAll,
 .singleSelectList .MuiAutocomplete-listbox {
 background: ${({ theme }) => theme.dropdown.bgColor};
}
 .MuiAutocomplete-listbox {
  background: ${({ theme }) => theme.dropdown.bgColor} !important;
}
 .vehicle-stamp {
 color: ${({ theme }) => theme.fleetHealth.color} ;
 background: ${({ theme }) => theme.fleetHealth.cardBg} ;
}
 .singleUpdation{
  background: ${({ theme }) => theme.singleUpdate.bgColor} ;
}
  .apexcharts-legend-text{
  color: ${({ theme }) => theme.fleetHealth.color} !important;
  }
  .MuiRadio-root{
    color: ${({ theme }) => theme.fleetHealth.color};
  }
    .textField{
        color: ${({ theme }) => theme.fleetHealth.color};
        font-size: 1.8rem;
    }
        .react-datepicker__navigation--previous {
  border-right-color: ${({ theme }) =>
    theme.navigationDatepickerPrev.borderRightColor} !important;
}

.react-datepicker__navigation--next {
  border-left-color: ${({ theme }) =>
    theme.navigationDatepickerNext.borderLeftColor} !important;
}
  .dropdown-selected{
   background: ${({ theme }) => theme.singleUpdate.bgColor};
  }
   .pagination-dropdown select{
   background: ${({ theme }) => theme.singleUpdate.bgColor};
   color: ${({ theme }) => theme.fleetHealth.color};
   }
   .dropdown-options{
      background: ${({ theme }) => theme.darrkThemeColor.bgColor};
   color: ${({ theme }) => theme.darrkThemeColor.color} !important;
   }
   .page-size-selected, .page-size-options{
         background: ${({ theme }) => theme.darrkThemeColor.bgColor};
   color: ${({ theme }) => theme.darrkThemeColor.color};
   }
   .dd-box, .dd-menu{
  background: ${({ theme }) => theme.darrkThemeColor.bgColor};
   color: ${({ theme }) => theme.darrkThemeColor.color};
   }
   .dd-item{
      color: ${({ theme }) => theme.darrkThemeColor.color};
   }
      .text-gray-color{
      color: ${({ theme }) => theme.darrkThemeColor.color};
      }
      .shareReports.cardSecondary .datePicker .email-date .react-datepicker-wrapper input{
      color: ${({ theme }) => theme.darrkThemeColor.color};
      }
      .dropdownList{
        background: ${({ theme }) => theme.darrkThemeColor.bgColor};
   color: ${({ theme }) => theme.darrkThemeColor.color};
      }
     .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover{
        background: ${({ theme }) => theme.darrkThemeColor.bgColor} !important;
}
        .select__multi-value--is-disabled, .select__multi-value__label{
         color: ${({ theme }) => theme.darrkThemeColor.color} !important;
        }
 .dtc-legend {
    div {
      color: ${({ theme }) => theme.fleetHealth.color} ;
}
}
.tabWraper .MuiTabs-scroller .MuiButtonBase-root{
      background: ${({ theme }) => theme.helpFooter.bgColor} !important;
      color: ${({ theme }) => theme.helpFooter.color} !important;
      margin-right: 5px;
}
      .searchWrapper .MuiFormLabel-root{
      color: ${({ theme }) => theme.darrkThemeColor.color} !important;
      }
      .selectAll {
color: ${({ theme }) => theme.darrkThemeColor.color} !important;
background: ${({ theme }) => theme.darrkThemeColor.bgColor} !important;
}
.react-datepicker__month--disabled, .react-datepicker__quarter--disabled {
  background-color: transparent !important;
  color: ${({ theme }) => theme.disabledColor.color} !important;
}
 .react-datepicker__month-text, .react-datepicker-year-header
{
color: ${({ theme }) => theme.darrkThemeColor.color};
   }
.month-picker-input {
background: ${({ theme }) => theme.darrkThemeColor.bgColor} !important;
color: ${({ theme }) => theme.darrkThemeColor.color};
}
.language-container{
color: ${({ theme }) => theme.darrkThemeColor.color} !important;
background: ${({ theme }) => theme.darrkThemeColor.bgColor} !important;
}
.slick-dots li.slick-active button:before{
color: ${({ theme }) => theme.darrkThemeColor.color} !important;
}
.slick-dots li button:before{
color: ${({ theme }) => theme.darrkThemeColor.color} !important;
}
`;
